import React, { useState, useEffect, useMemo, useCallback } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import moment from 'moment';
import 'moment/locale/fr';
import { Icon, Popup } from "../..";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var DateCellWrapper = function DateCellWrapper(props) {
  var children = props.children,
    segmentRef = props.segmentRef,
    form = props.form,
    value = props.value,
    openPopup = props.openPopup,
    onClose = props.onClose,
    selectedTab = props.selectedTab,
    mountNode = props.mountNode;
  var _useState = useState(false),
    editIsVisible = _useState[0],
    setEditIsVisible = _useState[1];
  var _useState2 = useState(null),
    childProps = _useState2[0],
    setChildProps = _useState2[1];
  var _useState3 = useState(false),
    selected = _useState3[0],
    setSelected = _useState3[1];
  useEffect(function () {
    setSelected(_.findIndex(selectedTab, function (d) {
      return moment(d).format('Y-MM-DD') === moment(value).format('Y-MM-DD');
    }) !== -1);
  }, [selectedTab, setSelected, value]);
  useEffect(function () {
    if (children && !_.isNil(children)) {
      var childPropsTmp = _.clone(children.props);
      childPropsTmp.className = _.replace(childPropsTmp.className, 'rbc-today', '');
      setChildProps(childPropsTmp);
    }
  }, [children]);
  var handleClose = useCallback(function () {
    setEditIsVisible(false);
    onClose();
  }, [setEditIsVisible, onClose]);
  useEffect(function () {
    if (openPopup) {
      setEditIsVisible(true);
    } else {
      setEditIsVisible(false);
    }
  }, [openPopup]);
  var handleMouseEnter = useCallback(function () {
    if (!_.isNil(childProps) && childProps.className.indexOf('rbc-off-range-bg') === -1 && !openPopup) {
      setEditIsVisible(true);
    }
  }, [childProps, openPopup]);
  var handleMouseLeave = useCallback(function () {
    if (!_.isNil(childProps) && childProps.className.indexOf('rbc-off-range-bg') === -1 && !openPopup) {
      setEditIsVisible(false);
    }
  }, [childProps, openPopup]);
  var renderPopup = useMemo(function () {
    return /*#__PURE__*/_jsx(Popup, {
      content: _.isNil(form) ? null : /*#__PURE__*/React.createElement(form.type, Object.assign({}, form.props, {
        selectedValues: selectedTab,
        onClose: handleClose
      })),
      open: openPopup,
      pinned: true,
      mountNode: mountNode,
      position: "center",
      size: "large",
      flowing: true,
      hoverable: true,
      trigger: /*#__PURE__*/_jsx("div", {
        className: "rbc-edit-hover",
        style: {
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          visibility: !_.isNil(editIsVisible) && editIsVisible || selected ? 'visible' : 'hidden',
          backgroundColor: 'rgba(49,116,173,0.5)'
        },
        children: /*#__PURE__*/_jsx(Icon, {
          name: "edit",
          size: "large",
          style: {
            color: 'white'
          }
        })
      })
    });
  }, [editIsVisible, form, handleClose, selected, openPopup, mountNode, selectedTab]);
  /* eslint-disable react/jsx-props-no-spreading */
  var wrapper = useMemo(function () {
    return /*#__PURE__*/_jsx("cell", Object.assign({
      ref: segmentRef
    }, childProps, {
      onMouseEnter: handleMouseEnter,
      onMouseLeave: handleMouseLeave,
      children: !_.isNil(form) ?
      /*#__PURE__*/
      // eslint-disable-next-line react/jsx-no-useless-fragment
      _jsx(_Fragment, {
        children: renderPopup
      }) : null
    }));
  }, [childProps, form, handleMouseEnter, handleMouseLeave, renderPopup, segmentRef]);
  return wrapper;
};
DateCellWrapper.handledProps = ["children", "form", "mountNode", "onClose", "openPopup", "segmentRef", "selectedTab", "value"];
DateCellWrapper.propTypes = {
  children: PropTypes.comp,
  segmentRef: PropTypes.ref,
  form: PropTypes.comp,
  value: PropTypes.date,
  openPopup: PropTypes.bool,
  onClose: PropTypes.func,
  selectedTab: PropTypes.arrayOf(PropTypes.date),
  mountNode: PropTypes.node
};
DateCellWrapper.defaultProps = {
  children: null,
  segmentRef: null,
  form: null,
  value: '',
  openPopup: false,
  onClose: null,
  selectedTab: []
};
export default DateCellWrapper;